import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import * as Papa from 'papaparse';


function stripHtmlTags(str: string) {
    /* Remove Tag HTML */
    str = str + '';
    str = str.replace(/<\/?[^>]+(>|$)/g, '');

    /*  Remove special charaters: <, >, ?, % | */
    return str.replace(/[<>?%]/g, '');
}
/**
 * Parse file as a multidimensional array
 * @param file
 */
export function parseFile(file: File, sheetName): Observable<Array<Array<any>>> {
    const reader: FileReader = new FileReader();

    const observable: Observable<Array<Array<any>>> = new Observable((observer) => {

        reader.onload = (e: any) => {
            /* read workbook */
            const bstr: string = e.target.result;
            const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

            /* grab sheet */
            const wsname = sheetName || wb.SheetNames[0];
            if (wb.SheetNames.includes(wsname)) {
                const ws: XLSX.WorkSheet = wb.Sheets[wsname];
                /* save data */
                let data = <Array<Array<any>>>(XLSX.utils.sheet_to_json(ws, { header: 1, defval: '', blankrows: false }));
                data = data.map((row) => row.map((cell) => stripHtmlTags(cell)));
                observer.next(data);
            } else {
                observer.error('Cannot find the sheet with name: ' + sheetName);
            }

        };
        reader.readAsBinaryString(file);

    });
    return observable;
}

export function exportDataJsonToExcel(fileName: string, sheetName: string, data: any): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    /* generate workbook and add the worksheet */
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    /* save to file */
    XLSX.writeFile(workbook, fileName);
}

export function readAsDataURL(file: File): Promise<string> {
    return new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event: any) => {
            resolve(event.target.result);
        };
    });
}

function sanitizeCSVData(data): CsvFileData {
    const headers: string[] = [];
    Object.keys(data[0]).forEach((key) => headers.push(stripHtmlTags(key)));
    const fileData: any[] = [];
    data.map((row) => {
        const currentRow = {};
        Object.keys(row).forEach((key) => {
            currentRow[stripHtmlTags(key)] = stripHtmlTags(row[key]);
        });
        fileData.push(currentRow);
    });
    return new CsvFileData(headers, fileData);
}


export function parseCSV(file: File): Observable<CsvFileData> {
    const observable: Observable<CsvFileData> = new Observable((observer) => {
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                if (results && results.data && results.data.length > 0) {
                    observer.next(sanitizeCSVData(results.data));
                } else {
                    observer.next(null);
                }
            }
        });

    });
    return observable;
}


export class CsvFileData {
    constructor(public headers?: string[],
                public data?: any[]) {
    }
}
